<div class="tab-container">
  <div class="skeleton">
    <div class="skeleton-tab-container">
    </div>    
  </div>
</div>
<div class="modal-body skeleton">
  <div class="row">
    <div class="col-md-3"><div class="skeleton-label"></div></div>
    <div class="col-md-3"><div class="skeleton-input"></div></div>
    <div class="col-md-3"><div class="skeleton-label"></div></div>
    <div class="col-md-3"><div class="skeleton-input"></div></div>
  </div>
  <div class="row">
    <div class="col-md-3"><div class="skeleton-label"></div></div>
    <div class="col-md-3"><div class="skeleton-input"></div></div>
    <div class="col-md-3"><div class="skeleton-label"></div></div>
    <div class="col-md-3"><div class="skeleton-input"></div></div>
  </div>
  <div class="row">
    <div class="col-md-3"><div class="skeleton-label"></div></div>
    <div class="col-md-3"><div class="skeleton-input"></div></div>
  </div>
  <div class="row">
    <div class="col-md-3"><div class="skeleton-label"></div></div>
    <div class="col-md-3"><div class="skeleton-input"></div></div>
    <div class="col-md-3"><div class="skeleton-label"></div></div>
    <div class="col-md-3"><div class="skeleton-input"></div></div>
  </div>
  <div class="row">
    <div class="col-md-3"><div class="skeleton-label"></div></div>
    <div class="col-md-3"><div class="skeleton-input"></div></div>
  </div>
  <div class="row">
    <div class="col-md-3"><div class="skeleton-label"></div></div>
    <div class="col-md-9"><div class="skeleton-input"></div></div>
  </div>
  <div class="row">
    <div class="col-md-3"><div class="skeleton-label"></div></div>
    <div class="col-md-9"><div class="skeleton-input"></div></div>
  </div>
  <div class="row">
    <div class="col-md-3"><div class="skeleton-label"></div></div>
    <div class="col-md-9"><div class="skeleton-input"></div></div>
  </div>
  <div class="row">
    <div class="col-md-3"><div class="skeleton-label"></div></div>
    <div class="col-md-1"><div class="skeleton-input"></div></div>
  </div>
  <div class="row">
    <div class="col-md-3"><div class="skeleton-label"></div></div>
    <div class="col-md-9"><div class="skeleton-input"></div></div>
  </div>
</div>